import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../../comun/Modal';

const Tratamientos = () => {
    const [servicios, setServicios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    
    // Modal y Formulario
    const [showModal, setShowModal] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        price: '',
        duration_minutes: 30,
        iva: 15
});

    const fetchServicios = async () => {
        try {
            setLoading(true);
            const response = await api.get('/api/treatments/');
            setServicios(response.data.results || response.data || []);
        } catch (err) {
            console.error('Error fetching servicios:', err);
            setError('Error al cargar la lista de servicios.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchServicios();
    }, []);

    const handleOpenModal = (servicio = null) => {
        if (servicio) {
            setEditingId(servicio.id);
            setFormData({
                name: servicio.name,
                description: servicio.description || '',
                price: servicio.price,
                duration_minutes: servicio.duration_minutes || 30,
                iva: servicio.iva ?? 15
            });
        } else {
            setEditingId(null);
            setFormData({ 
                name: '', description: '', price: '', duration_minutes: 30, iva: 15
            });
        }
        setShowModal(true);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            if (editingId) {
                await api.patch(`/api/treatments/${editingId}/`, formData);
            } else {
                await api.post('/api/treatments/', formData);
            }
            setShowModal(false);
            fetchServicios();
        } catch (err) {
            console.error('Error saving servicio:', err);
            alert('Error al guardar el servicio.');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Está seguro de eliminar este servicio?')) return;
        try {
            await api.delete(`/api/treatments/${id}/`);
            fetchServicios();
        } catch (err) {
            console.error('Error deleting servicio:', err);
            alert('Error al eliminar el servicio.');
        }
    };

    const styles = {
        container: { padding: '2rem', backgroundColor: '#f8f9fb', minHeight: '100vh' },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' },
        title: { margin: 0, fontSize: '1.75rem', color: '#1a1a2e', fontWeight: '800' },
        buttonPrimary: {
            padding: '0.75rem 1.5rem', borderRadius: '8px', backgroundColor: '#111827',
            color: '#fff', border: 'none', fontWeight: '700', cursor: 'pointer'
        },
        table: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' },
        th: { padding: '1rem', textAlign: 'left', backgroundColor: '#f1f5f9', color: '#475569', fontWeight: '700' },
        td: { padding: '1rem', borderBottom: '1px solid #e2e8f0', color: '#334155' },
        actionBtn: { background: 'none', border: 'none', cursor: 'pointer', margin: '0 5px', fontSize: '1.2rem' },
        formGroup: { marginBottom: '1rem' },
        label: { display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#1e293b', fontSize: '0.9rem' },
        input: { width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const uploadData = new FormData();
        uploadData.append('file', file);

        try {
            setLoading(true);
            const response = await api.post('/api/treatments/import-excel/', uploadData, { 
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            alert(response.data.message || '¡Servicios importados correctamente!');
            fetchServicios();
        } catch (err) {
            console.error('Error importing excel:', err);
            alert('Error al importar el archivo Excel: ' + (err.response?.data?.error || err.message));
        } finally {
            setLoading(false);
            e.target.value = ''; // Reset input
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div>
                    <h1 style={styles.title}>Catálogo de Servicios</h1>
                    <p style={{ margin: '0.5rem 0 0', color: '#64748b' }}>Gestione los servicios ópticos, exámenes oftalmológicos y sus precios</p>
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <label style={{ ...styles.buttonPrimary, backgroundColor: '#10b981', cursor: 'pointer', margin: 0, display: 'flex', alignItems: 'center' }}>
                        <i className="bi bi-file-earmark-excel me-2"></i> Importar Excel
                        <input type="file" accept=".xlsx, .xls, .csv" style={{ display: 'none' }} onChange={handleFileUpload} />
                    </label>
                    <button style={styles.buttonPrimary} onClick={() => handleOpenModal()}>
                        + Nuevo Servicio
                    </button>
                </div>
            </div>

            {error && <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>}

            {loading ? (
                <p>Cargando servicios...</p>
            ) : (
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>Nombre del Servicio</th>
                            <th style={styles.th}>Descripción</th>
                            <th style={styles.th}>Precio ($)</th>
                            <th style={styles.th}>IVA</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {servicios.map(srv => (
                            <tr key={srv.id}>
                                <td style={styles.td}><strong>{srv.name}</strong></td>
                                <td style={styles.td}>{srv.description || '-'}</td>
                                <td style={styles.td}>${parseFloat(srv.price).toFixed(2)}</td>
                                <td style={styles.td}>{(srv.iva ?? 15)}%</td>
                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                    <button style={{ ...styles.actionBtn, color: '#4b5563' }} onClick={() => handleOpenModal(srv)} title="Editar">
                                        <i className="bi bi-pencil-square"></i>
                                    </button>
                                    <button style={{ ...styles.actionBtn, color: '#ef4444' }} onClick={() => handleDelete(srv.id)} title="Eliminar">
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {servicios.length === 0 && (
                            <tr>
                                <td colSpan="4" style={{ ...styles.td, textAlign: 'center', color: '#64748b' }}>
                                    No hay servicios registrados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}

            <Modal isOpen={showModal} onClose={() => setShowModal(false)} title={editingId ? 'Editar Servicio' : 'Nuevo Servicio'}>
                <form onSubmit={handleSave} style={{ minWidth: '600px', maxHeight: '75vh', overflowY: 'auto', paddingRight: '10px' }}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Nombre del Servicio</label>
                        <input type="text" style={styles.input} required value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="Ej: Examen Visual Computarizado" />
                    </div>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>Descripción</label>
                        <textarea style={styles.input} rows="3" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} placeholder="Detalles opcionales..." />
                    </div>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <div style={{ ...styles.formGroup, flex: 1 }}>
                            <label style={styles.label}>Precio ($)</label>
                            <input type="number" step="0.01" min="0" style={styles.input} required value={formData.price} onChange={e => setFormData({ ...formData, price: e.target.value })} />
                        </div>
                        <div style={{ ...styles.formGroup, flex: 1 }}>
                            <label style={styles.label}>IVA en factura</label>
                            <select style={styles.input} value={formData.iva} onChange={e => setFormData({ ...formData, iva: Number(e.target.value) })}>
                                {[0, 5, 12, 14, 15].map(t => <option key={t} value={t}>{t === 0 ? 'IVA 0% (no grava)' : `IVA ${t}%`}</option>)}
                            </select>
                        </div>
                        <div style={{ ...styles.formGroup, flex: 1 }}>
                            <label style={styles.label}>Duración Estimada (min)</label>
                            <input type="number" min="5" style={styles.input} required value={formData.duration_minutes} onChange={e => setFormData({ ...formData, duration_minutes: e.target.value })} />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '1.5rem' }}>
                        <button type="button" onClick={() => setShowModal(false)} style={{ padding: '0.75rem 1.5rem', borderRadius: '8px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
                        <button type="submit" style={styles.buttonPrimary}>Guardar Servicio</button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default Tratamientos;
